<template>
	<c-dialog ref="dialog" title="委外单详情" mode="slide" width="100vw-300" enable-flex mask-close :button="false">
		<template #head>
			<div v-if="detailData.order_code" class="m-detail-tag flex-center-cross">
				<label>{{detailData.order_code}}</label>
				<c-state dict="orderStateDic" tag :value="detailData.state"></c-state>
				<c-state dict="priorityDic" tag :value="detailData.priority"></c-state>
				<c-state type="expectedDate" tag :value="detailData.expected_date"></c-state>
			</div>
		</template>
		
		<module>
			<module-col size="350">
				<c-detail class="m-detail-form">
					<c-detail-item label="委外单二维码">
						<c-qrcode :value="detailData.h5_web" size="100"></c-qrcode>
					</c-detail-item>
					<c-detail-item label="供应商">
						{{detailData.supplier_name}}
					</c-detail-item>
					<c-detail-item label="产品编号">
						{{detailData.product_code}}
					</c-detail-item>
					<c-detail-item label="产品名称">
						{{detailData.product_name}}
						<span v-if="detailData.product_spec"> [{{detailData.product_spec}}]</span>
					</c-detail-item>
					<c-detail-item label="产品单位">
						{{detailData.unit}}
					</c-detail-item>
					<c-detail-item label="工序名称">
						{{detailData.process_name}}
					</c-detail-item>
					<c-detail-item label="进度">
						<c-progress :rate="[detailData.receive_count, detailData.plan_count]" :color="((detailData.receive_count/detailData.plan_count)>=1||detailData.plan_count==0) ?'green':'blue'"></c-progress>
					</c-detail-item>
					<c-detail-item label="外发数">
						{{detailData.plan_count}}
					</c-detail-item>
					<c-detail-item label="待回数">
						{{detailData.wait_return_count}}
					</c-detail-item>
					<c-detail-item label="已回数">
						{{detailData.receive_count}}
					</c-detail-item>
					<c-detail-item label="待发料数">
						{{detailData.wait_send_count}}
					</c-detail-item>
					<c-detail-item label="已发料数">
						{{detailData.send_count}}
					</c-detail-item>
					<c-detail-item label="单价">
						{{detailData.price}}
					</c-detail-item>
					<c-detail-item label="金额">
						{{detailData.money}}
					</c-detail-item>
					<c-detail-item label="完成金额">
						{{detailData.completed_money}}
					</c-detail-item>
					<c-detail-item label="结算金额">
						{{detailData.settled_money}}
					</c-detail-item>
					<c-detail-item label="计划交期">
						{{detailData.estimated_delivery_date}}
					</c-detail-item>
					<c-detail-item label="实际交期">
						{{detailData.real_delivery_date}}
					</c-detail-item>
					<c-detail-item label="最新动态">
						{{detailData.last_progress}}
					</c-detail-item>
					<c-detail-item label="备注">
						{{detailData.remark}}
					</c-detail-item>
					<c-detail-item label="创建人">
						{{detailData.create_user_realname}}
					</c-detail-item>
					<c-detail-item label="创建时间">
						{{detailData.create_date}}
					</c-detail-item>
					<c-detail-item label="关联工单">
						<c-link v-if="auth('m_work')" @click="globalDialog('workDetail', {props: {id: detailData.work_id}})">{{detailData.work_code}}</c-link>
						<span v-else>{{detailData.work_code}}</span>
					</c-detail-item>
					<c-detail-item v-if="detailData.ref_code" label="关联单据">
						<order-link :type="detailData.ref_type" :id="detailData.ref_id" :code="detailData.ref_code"></order-link>
					</c-detail-item>
				</c-detail>
			</module-col>

			<module-col tab-type="border-tab">
				<module-tab name="委外单信息" enable-flex>
					<div class="m-detail-box">
						<c-title>委外动态</c-title>
						<custom-table ref="progressTable" view-id="20008" height="grow" readonly>
							<!--动态类型-->
							<template #progress_type="{data}">
								<c-state dict="outSourcingOrderProcessName" tag :value="data.progress_type"></c-state>
							</template>

							<!--创建人类型-->
							<template #create_user_type="{data}">
								<c-state dict="outSourcingOrderProcessCreateUserType" tag :value="data.create_user_type"></c-state>
							</template>

							<!--附件-->
							<template #attachment_file_url="{data}">
								<c-file v-if="data.attachment_file_url" :src="data.attachment_file_url" media></c-file>
							</template>
						</custom-table>
						
						<c-title>委外结算单</c-title>
						<custom-table ref="settleTable" view-id="20009" height="grow" readonly></custom-table>
					</div>
				</module-tab>
			</module-col>
		</module>
	</c-dialog>
</template>

<script>
	export default {
		name: 'outSourcingDetail',

		props: {
			id: [String, Number]
		},
		
		data() {
			return {
				detailData: {}
			}
		},

		methods: {
			open() {
				this.request({
					url: '/out/sourcing/order/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.detailData = data.detailInfo;
						this.$refs.progressTable.init();
						this.$refs.settleTable.init();
						this.$refs.progressTable.$refs.list.setData(data.process_list);
						this.$refs.settleTable.$refs.list.setData(data.settle_list);
						this.$refs.dialog.open();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>